module.exports = __webpack_public_path__ + "8a8ab5ad6761de5efa9dfa19dc75de0f.MP3";